<template>
    <div id="main" style="padding:20px;">

        <div align="left" style="font-weight: bold; font-size: 20px">
            统计数据
        </div>

        <div align="left" style="margin-bottom: 20px">截止时间：{{lastUpdateTime | uptotime}}</div>

        <div class="selectCountry">
            <select class="form_group" v-model="selectCountry" @change="changeCountry">
                <option value="">选择国家</option>
                <option v-for="(item,index) of countryArray" :key="index" :value="item.countryId">{{item.countryName}}</option>
            </select>
        </div>

        <div class="country_total">
            <div class="country_total tag_title">{{countryName}}</div>
            <div class="country_total counts">
                <section class="country_total section">
                    <div class="country_total first-child">新增：<span class="country_total nth-child">+{{countryNewConfirm}}</span>
                    </div>
                    <strong class="country_total strong nth-child">{{countryTotalConfirm}}</strong>
                    <div class="country_total confirm">确诊</div>
                </section>
                <section class="country_total section">
                    <strong class="country_total strong nth-child2">{{countryTreatment}}</strong>
                    <div class="country_total confirm">治愈</div>
                </section>
                <section class="country_total section">
                    <div class="country_total first-child">新增：<span class="country_total nth-child3">+{{countryNewDeath}}</span>
                    </div>
                    <strong class="country_total strong nth-child3">{{countryTotalDeath}}</strong>
                    <div class="country_total confirm">死亡</div>
                </section>
            </div>
        </div>

        <div id="define" style="height: 300px; width: 100%; margin-top: 20px"></div>

        <div id="death" style="height: 300px; width: 100%; margin-top: 40px"></div>

        <div id="treatment" style="height: 300px; width: 100%; margin-top: 40px"></div>

        <div align="left" style="margin-top: 20px;font-weight: bold; font-size: 20px">
            南美病例
        </div>
        <div style="width: 100%; height: 100%; margin-top: 20px;">
            <el-table
                    :data="countryArray"
                    style="width: 100%"
                    row-key="countryId"
                    border
                    :header-cell-style="tableHeaderColor"
                    :cell-style="tableCell"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                <el-table-column prop="countryName" label="地区">
                </el-table-column>
                <el-table-column prop="countryTotalConfirm" label="确诊">
                </el-table-column>
                <el-table-column prop="countryTotalDeath" label="死亡">
                </el-table-column>
                <el-table-column prop="countryDeathRate" label="病死率">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>


<script>
    import moment from 'moment-timezone'
    import {ajaxPost} from '../api/ajax'

    export default {
        name: "Statistics",
        data() {
            return {
                lastUpdateTime: 0,
                selectCountry: 0,
                countryArray: [], // 国家列表
                chartDefine: '', // 确诊折线图
                chartDeath: '', // 死亡折线图
                chartTreatment: '', // 治愈折线图
                countryName: '', // 国家名
                countryTotalConfirm: 0, // 国家累计确诊
                countryTotalDeath: 0, // 国家累计死亡
                countryTreatment: 0, // 治愈数
                countryNewDeath: 0, // 国家新增死亡
                countryNewConfirm: 0, // 国家新增确诊
                timestamp: 0, // 当天(年月日)的时间戳
                totalConfirm: [], // 累计确诊
                newConfirm: [], // 新增确诊
                totalDeath: [], // 累计死亡
                newDeath: [], // 新增死亡
                totalTreatment: [], // 累计死亡
                newTreatment: [], // 新增死亡
                dateArray: [], // 折线图x轴日期
                defineOption: { // 累计确诊 新增确诊折线图数据
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['累计确诊', '新增确诊']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    },
                    yAxis: {
                        type: 'value',
                        minInterval: 1
                    },
                    series: []
                },
                deathOption: { // 累计死亡 新增死亡折线图数据
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['累计死亡', '新增死亡']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    },
                    yAxis: {
                        type: 'value',
                        minInterval: 1
                    },
                    series: []
                },
                treatmentOption: { // 累计治愈 新增治愈折线图数据
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['累计治愈', '新增治愈']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    },
                    yAxis: {
                        type: 'value',
                        minInterval: 1
                    },
                    series: []
                },
                tableData: []
            }
        },
        mounted() {
            this.chartDefine = this.$echarts.init(document.getElementById('define'))
            this.chartDeath = this.$echarts.init(document.getElementById('death'))
            this.chartTreatment = this.$echarts.init(document.getElementById('treatment'))
            let beijingDate = this.getLocalTime(8)
            this.timestamp = Date.parse(beijingDate)
            this.getCountryList()
        },
        methods: {
            getLocalTime(i) {
                let d = new Date()
                //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
                if (typeof i !== 'number') return;
                //得到1970年一月一日到现在的秒数
                let len = d.getTime();
                //本地时间与GMT时间的时间偏移差
                let offset = d.getTimezoneOffset() * 60000;
                //得到现在的格林尼治时间
                let utcTime = len + offset;
                let beijingDate = new Date(utcTime + 3600000 * i);
                return moment(beijingDate).format('YYYY/MM/DD');
            },
            getCountryList() {// 获取国家
                ajaxPost(this.$store.state.baseurl + '/cov/nm/country/list', {}).then((response) => {
                    if (response.code === 200) {
                        this.countryArray = response.info
                        this.selectCountry = response.info[0].countryId
                        this.countryName = response.info[0].countryName
                        this.getCountryTotal()
                        this.getDayTotal()
                    }
                }).catch((response) => {
                    console.log(response)
                })
            },
            changeCountry() {
                if (this.selectCountry && this.selectCountry > 0) {
                    this.defineOption.xAxis.data = []
                    this.deathOption.xAxis.data = []
                    this.treatmentOption.xAxis.data = []
                    this.defineOption.series = []
                    this.deathOption.series = []
                    this.treatmentOption.series = []
                    this.getCountryTotal()
                    this.getDayTotal()
                }
            },
            getCountryTotal() {// 获取国家累计数据
                if (this.selectCountry > 0) {
                    ajaxPost(this.$store.state.baseurl + '/cov/nm/country/total', {
                        countryId: this.selectCountry,
                        dayTime: this.timestamp
                    }).then((response) => {
                        if (response.code === 200) {
                            this.countryName = response.info.countryName
                            this.countryTotalConfirm = response.info.countryTotalConfirm
                            this.countryTotalDeath = response.info.countryTotalDeath
                            this.countryTreatment = response.info.countryTreatment
                            this.lastUpdateTime = response.info.lastUpdateTime
                            this.countryNewDeath = response.info.countryNewDeath
                            this.countryNewConfirm = response.info.countryNewConfirm
                        }
                    }).catch((response) => {
                        console.log(response)
                    })
                }
            },
            getDayTotal() {// 获取最近一个月数据
                if (this.selectCountry > 0) {
                    ajaxPost(this.$store.state.baseurl + '/cov/nm/country/day', {
                        countryId: this.selectCountry,
                        dayTime: this.timestamp
                    }).then((response) => {
                        if (response.code === 200) {
                            this.totalConfirm = []
                            this.newConfirm = []
                            this.totalDeath = []
                            this.newDeath = []
                            this.totalTreatment = []
                            this.newTreatment = []
                            this.dateArray = []
                            for (let i = response.info.length - 1; i > -1; i--) {
                                this.totalConfirm.push(response.info[i].dayTotalConfim)
                                this.newConfirm.push(response.info[i].dayNewConfim)
                                this.totalDeath.push(response.info[i].dayTotalDeath)
                                this.newDeath.push(response.info[i].dayNewDeath)
                                this.totalTreatment.push(response.info[i].dayTotalTreatment)
                                this.newTreatment.push(response.info[i].dayNewTreatment)
                                this.dateArray.push(moment(parseInt(response.info[i].dayTime)).format('M/DD'))
                            }
                            this.defineOption.xAxis.data = this.dateArray
                            this.deathOption.xAxis.data = this.dateArray
                            this.treatmentOption.xAxis.data = this.dateArray
                            this.defineOption.series.push({
                                name: '累计确诊',
                                type: 'line',
                                data: this.totalConfirm,
                                itemStyle: {
                                    normal: {
                                        color: '#FF8C00', //改变折线点的颜色
                                        lineStyle: {
                                            color: '#FF8C00' //改变折线颜色
                                        }
                                    }
                                },
                            })
                            this.defineOption.series.push({
                                name: '新增确诊',
                                type: 'line',
                                data: this.newConfirm,
                                itemStyle: {
                                    normal: {
                                        color: '#3CB371', //改变折线点的颜色
                                        lineStyle: {
                                            color: '#3CB371' //改变折线颜色
                                        }
                                    }
                                },
                            })
                            this.deathOption.series.push({
                                name: '累计死亡',
                                type: 'line',
                                data: this.totalDeath,
                                itemStyle: {
                                    normal: {
                                        color: '#800080', //改变折线点的颜色
                                        lineStyle: {
                                            color: '#800080' //改变折线颜色
                                        }
                                    }
                                },
                            })
                            this.deathOption.series.push({
                                name: '新增死亡',
                                type: 'line',
                                data: this.newDeath,
                                itemStyle: {
                                    normal: {
                                        color: '#375F83', //改变折线点的颜色
                                        lineStyle: {
                                            color: '#375F83' //改变折线颜色
                                        }
                                    }
                                },
                            })
                            this.treatmentOption.series.push({
                                name: '累计治愈',
                                type: 'line',
                                data: this.totalTreatment,
                                itemStyle: {
                                    normal: {
                                        color: '#26B9A4', //改变折线点的颜色
                                        lineStyle: {
                                            color: '#26B9A4' //改变折线颜色
                                        }
                                    }
                                },
                            })
                            this.treatmentOption.series.push({
                                name: '新增治愈',
                                type: 'line',
                                data: this.newTreatment,
                                itemStyle: {
                                    normal: {
                                        color: '#52CC33', //改变折线点的颜色
                                        lineStyle: {
                                            color: '#52CC33' //改变折线颜色
                                        }
                                    }
                                },
                            })
                            this.chartDefine.setOption(this.defineOption)
                            this.chartDeath.setOption(this.deathOption)
                            this.chartTreatment.setOption(this.treatmentOption)
                        }
                    }).catch((response) => {
                        console.log(response)
                    })
                }
            },
            //设置表头行的样式
            tableHeaderColor() {
                return 'background-color:#B0C4DE;color:#000000;font-wight:500;text-align:center'
            },
            tableCell() {
                return 'text-align:center'
            }
        },
        filters: {
            uptotime: function (value) {
                //console.log("1111111111111", + moment.tz.zone('America/Los_Angeles').abbr(1403465838805))
                if (value > 0) {
                    return moment(parseInt(value)).format('YYYY/MM/DD HH:mm')
                } else {
                    return ''
                }
            },
        }
    }
</script>

<style scoped>

    .selectCountry{
        margin-bottom: 70px;
    }

    .form_group {
        width: auto;
        min-width: 200px;
        height: 22px;
        position: relative;
        float: left;
    }

    .country_total {
        border-radius: 4px;
        pastronging: 5px 0px;
        background-color: #f3f3f3;
        display: inline-block;
        text-align: center;
        color: #888;
        word-break: break-all;
        padding: 3px 0px;
        width: 60%;
    }

    @media (max-width: 450px) {
        .country_total {
            border-radius: 4px;
            pastronging: 5px 0px;
            background-color: #f3f3f3;
            display: inline-block;
            text-align: center;
            color: #888;
            word-break: break-all;
            padding: 3px 0px;
            width: 100%;
        }
    }

    .tag_title {
        font-weight: bolder;
        font-size: 14px;
    }

    .counts {
        width: 100%;
        display: flex;
        justify-content: space-around;
    }

    .section {
        margin: 0px;
        display: flex;
        flex-direction: column;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: end;
        justify-content: flex-end;
        line-height: 20px;
    }

    .first-child {
        font-size: 0.55rem;
    }

    .nth-child {
        color: #f60;
        width: auto;
    }

    .nth-child2 {
        color: #26b8a4;
    }

    .nth-child3 {
        color: #5e7092;
        width: auto;
    }

    .strong {
        font-size: 1.3rem;
        font-weight: 600;
        margin: 0px;
        font-family: monospace;
    }

    .confirm {
        font-size: 0.6rem;
    }

</style>
